import { createGlobalStyle } from 'styled-components';
import GTWalsheimProBlack from 'assets/fonts/GT-Walsheim-Pro-Black.woff';
import GTWalsheimProBold from 'assets/fonts/GT-Walsheim-Pro-Bold.woff';
import GTWalsheimProMedium from 'assets/fonts/GT-Walsheim-Pro-Medium.woff';
import GTWalsheimProRegular from 'assets/fonts/GT-Walsheim-Pro-Regular.woff';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  }
  @font-face {
    font-family: 'GT Walsheim Pro Black';
    src: url(${GTWalsheimProBlack}) format('opentype');
  }
  @font-face {
    font-family: 'GT Walsheim Pro Bold';
    src: url(${GTWalsheimProBold}) format('opentype');
  }
  @font-face {
    font-family: 'GT Walsheim Pro Medium';
    src: url(${GTWalsheimProMedium}) format('opentype');
  }
  @font-face {
    font-family: 'GT Walsheim Pro Regular';
    src: url(${GTWalsheimProRegular}) format('opentype');
  }

  #root {
    height: 100%;

    input::-ms-input-placeholder { /* Internet Explorer 10-11 */
      opacity: 0.3;
    }

    input::-webkit-contacts-auto-fill-button,
    input::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    input:-ms-input-placeholder { /* Microsoft Edge */
      opacity: 0.3;
    }
    /* remove autocomplete background color */
    input:-webkit-autofill {
        box-shadow: 0 0 0 30px white inset !important;
    }

    input::placeholder {
      opacity: 0.3;
    }
    word-break: 'break-word',
  }
  .gu-mirror {
    background-color: rgba(16, 142, 233, 0.15);
    border-spacing: 15px;
  }
  
  
`;

export { GlobalStyle };
